export default __webpack_public_path__ + "static/media/logo-transparent.fda85f58.png";